import { RDate } from "../../core";
import { DateRange } from "../../core/DateRange";
import { AbsoluteDatePreorderSetting } from "./AbsoluteDatePreorderSetting";
import { IntersectionPreorderSettings } from "./IntersectionPreorderSettings";
import { RelativeDatePreorderSetting } from "./RelativeDatePreorderSetting";
import { SameDayPreorderSetting } from "./SameDayPreorderSetting";
import { UnionPreorderSettings } from "./UnionPreorderSettings";
export const PreorderSettings = {
    create(params) {
        switch (params.preorderSettings.tag) {
            case "SameDay":
                return new SameDayPreorderSetting(params.orderingHours);
            case "RelativeDate":
                return new RelativeDatePreorderSetting(params.preorderSettings.maxDays);
            case "AbsoluteDate": {
                const begin = RDate.fromLocalTimeString(params.preorderSettings.from, params.timezone);
                const end = RDate.fromLocalTimeString(params.preorderSettings.to, params.timezone).endOfDay();
                const range = DateRange.fromDates({ begin, end });
                return new AbsoluteDatePreorderSetting(range);
            }
        }
    },
    union(settings) {
        return new UnionPreorderSettings(settings);
    },
    intersection(settings) {
        return new IntersectionPreorderSettings(settings);
    },
};
